import { render } from "./EntryList.vue?vue&type=template&id=1823ec4e&scoped=true"
import script from "./EntryList.vue?vue&type=script&lang=js"
export * from "./EntryList.vue?vue&type=script&lang=js"

import "./EntryList.vue?vue&type=style&index=0&id=1823ec4e&scoped=true&lang=css"

import exportComponent from "/app/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1823ec4e"]])

export default __exports__